export const abi = [
  // ERC-721 standard functions
  {
    type: "constructor",
    inputs: [
      {
        internalType: "address",
        name: "defaultRoyaltyRecipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "defaultRoyaltyPercentage",
        type: "uint256",
      },
      { internalType: "address[]", name: "admins", type: "address[]" },
      { internalType: "bool", name: "enableStory", type: "bool" },
      { internalType: "address", name: "blockListRegistry", type: "address" },
    ],
    stateMutability: "nonpayable",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "previousAdmin",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "AdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "beacon",
        type: "address",
      },
    ],
    name: "BeaconUpgraded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "implementation",
        type: "address",
      },
    ],
    name: "Upgraded",
    type: "event",
  },
  {
    stateMutability: "payable",
    type: "fallback",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
  {
    type: "function",
    name: "balanceOf",
    inputs: [{ name: "owner", type: "address" }],
    outputs: [{ name: "balance", type: "uint256" }],
    constant: true,
    stateMutability: "view",
  },
  {
    type: "function",
    name: "tokenOfOwnerByIndex",
    inputs: [
      { name: "owner", type: "address" },
      { name: "index", type: "uint256" },
    ],
    outputs: [{ name: "tokenId", type: "uint256" }],
    constant: true,
    stateMutability: "view",
  },
  // ERC-721 standard events
  {
    type: "event",
    name: "Transfer",
    inputs: [
      { name: "from", type: "address", indexed: true },
      { name: "to", type: "address", indexed: true },
      { name: "tokenId", type: "uint256", indexed: false },
    ],
    anonymous: false,
  },
];
